import React from 'react';
import { Link } from 'react-router-dom';
import './components.css';

const Header = () => {
    return (
        <nav className="navbar navbar-light bg-light">
            <Link className="navbar-brand" to={`/`}>
                <img src="./favicon/android-chrome-512x512.png" className="d-inline-block align-top" alt="" />
                <h3>Zorgnetwerk Trento</h3>
            </Link>
        </nav>
    );
};

export default Header;
